import { useI18n } from '../../../i18n';
import { TAB_TYPE_BUYING, Tab } from '../constants';
import { TransactionStatus, DeliveryType } from '../../../../typings/transaction';

type GetStatusI18nType = {
  tabType: Tab;
  orderStatus: TransactionStatus | 'SHIPMENT_CODE_RECEIVED' | '';
  isInfo: boolean;
  deliveryType: DeliveryType;
  params?: Record<string, any>;
};

export default function useGetOrderStatusI18n() {
  const i18n = useI18n();
  const getTabType = (type: Tab) => (type === TAB_TYPE_BUYING ? 'buyer' : 'seller');
  const getIsInfo = (info: boolean) => (info ? 'info_' : '');

  return ({ tabType, orderStatus, isInfo, params = {} }: GetStatusI18nType) => {
    const dlvStatusDefault = `dlv_status_${getIsInfo(isInfo)}${orderStatus.toLowerCase()}`;
    const dlvStatusByTab = `dlv_status_${getIsInfo(isInfo)}${getTabType(
      tabType,
    )}_${orderStatus.toLowerCase()}`;

    return i18n(dlvStatusDefault, '', params) || i18n(dlvStatusByTab, '', params);
  };
}
